import { useIntl } from '@/intl'
import { Banner } from '@sunwebgroup/ui-components/uds'

export function NoReviewsMessage() {
  const intl = useIntl()
  return (
    <Banner
      size="M"
      text={intl.formatMessage({ id: 'reviews_no_reviews_title' })}
      supportingText={intl.formatMessage({ id: 'reviews_no_reviews_content' })}
      color="secondary"
    />
  )
}
